import React from 'react'

export default function Header() {
    return (
        <div className="text-gray-500 font-bold bg-gray-800 w-full content-center overflow-hidden shadow-xl rounded py-2">
            <h1 className="text-center text-4xl">NSC-Download-Browser</h1>
        </div>
    )
}
